import React from "react";
import { createClasses } from "@bloomberg/media-ui-core";

import { NEWSLETTER_TOUT_CLASSES } from "~constants";

import styles from "./inlineNewsletter.module.css";

type InlineNewsletterProps = {
    position: keyof typeof NEWSLETTER_TOUT_CLASSES;
};

export default function InlineNewsletter({ position }: InlineNewsletterProps) {
    // NEWSLETTER_TOUT_CLASSES[position] provides the hardcoded classname that plug-client expects to inject the newsletter
    const cx = createClasses([
        styles[NEWSLETTER_TOUT_CLASSES[position]],
        NEWSLETTER_TOUT_CLASSES[position],
    ]);

    return <div className={cx} data-component="plug-newsletter" />;
}
